import { makeStyles } from '@material-ui/core/styles';

export const paletteTheme = {
    palette: {
        primary: {
            light: '#757ce8',
            // main: '#3f50b5',
            main: '#5D88A2',
            dark: '#002884',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#f44336',
            dark: '#ba000d',
            contrastText: '#000',
        }
    }
}
export const GlobalTheme = {
    light: {
        primary: '#ffffff',
        secondary: '#0C76D8',
        card: '#A8ABAD',
        body: '#E2E2E2',
        headerColor: '#000',
        headerBackground: '#A8ABAD',
        text: '#363537',
        toggleBorder: '#FFF',
        gradient: 'linear-gradient(#39598A, #79D7ED)',
        palette: {
            paletteTheme,
            type: 'light'
        },
        background: '#fbfbfb',
        alternateGridRow: '#FFFFFF',
        borderColor: '#000000',
        color: 'black'
    }
    ,
    dark: {
        primary: '#5D88A2',
        secondary: '#E45B1A',
        card: '#A8ABAD',
        body: '#363537',
        text: '#FAFAFA',
        headerColor: '#fff',
        headerBackground: '#303030',
        toggleBorder: '#6B8096',
        gradient: 'linear-gradient(#091236, #1E215D)',
        palette: {
            paletteTheme,
            type: 'dark'
        },
        background: 'black',
        alternateGridRow: '#424242',
        borderColor: '#FFFFFF'
    }
}

export const TileTheme = makeStyles(theme => ({
    card: {
        width: '246px !important',
        [theme.breakpoints.up('1180')]: {
            width: '362px !important',
        },
        height: '314px',
        margin: '5px !important'
    },
    cardLow: {
        width: '246px !important',
        [theme.breakpoints.up('1180')]: {
            width: '362px !important',
        },
        height: '94px',
        margin: '5px 5px 15px 5px!important'
    },
    cardContent: {
        padding: '0px'
    },
    title: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '18px'
    },
    subTitle: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '21px',
        height: '23px',
        marginBottom: '1rem',
        color: '#282E38'
    },
    optionText: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        color: '#64748B'
    },
    optionBlock: {
        display: 'inline-block',
        marginRight: '5px',
        width: '13px',
        height: '13px'
    }
}));